import { NewPageComponent } from './../../templates/new-page/new-page.component';
import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ActivatedRoute } from '@angular/router';
import { ExtraService } from '../../core/services/extra.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { from } from 'rxjs/observable/from';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { Constants } from '../../core/config/Constants'

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.css'],
  providers: [ExtraService]
})
export class ActivitiesComponent{

  public page = {
    title: "Activities",
    slug: "Activities"
  };

  constructor() { }

}



// WEBPACK FOOTER //
// /app/src/app/event/activities/activities.component.ts